export const RESPONSE = {
  Success: {
    '200': {
      message: 'ok',
      code: 200,
    }
  }
}

export enum AxiosServiceCacheKey {
  Business = 2,
}